var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"future-alert-box"},[_c('span',{staticClass:"title"},[_vm._v("\n      🕐 "+_vm._s(_vm.$t('future_alert.title'))+"\n  ")]),_c('span',{staticClass:"info"},[_vm._v("\n       "+_vm._s(_vm.$t('future_alert.info', {
           date: _vm.formattedDate
       }))+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }